<template>
  <div class="menu-panel-list">
    <template v-for="(panel, index) in panellist" >
      <a v-if="panel.link" :href="panel.link" :class="['menu-panel-item', {published:(panel.published === 'yes')}]" :key="`panel-${index}`" >
        <img v-if="panel.image" :src="getSource(panel.image)" :alt="panel.title" class="panel-tampnail" />
        <img v-else :src="getSource('template/placeholder-image.png')" alt="st-sample-image" class="panel-tampnail" />
        <div class="menu-panel-content">
          <h3>{{panel.word}}</h3>
          <p>{{panel.title}}</p>
        </div>
      </a>
      <div v-else :href="panel.link" class="menu-panel-item" :key="`panel-${index}`" >
        <img v-if="panel.image" :src="getSource(panel.image)" :alt="panel.title" class="panel-tampnail" />
        <img v-else :src="getSource('template/placeholder-image.png')" alt="st-sample-image" class="panel-tampnail" />
        <div class="menu-panel-content">
          <h3>{{panel.word}}</h3>
          <p>{{panel.title}}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {store} from './ProjectStore.js'

export default {
  data() {
    return {

    }
  },
  computed: {
    panellist () {
      return store.panelList
    }
  },
   methods: {
      getSource (value) {
        if (!value) return null
        return require(`images/${value}`)
      }
    }
}
</script>

<style lang="scss">
.menu-panel-list {
  padding:0 20px;
  box-sizing: border-box;
  .menu-panel-item {
    display: flex;
    align-items: center;
    padding: 20px 0;
    box-sizing: border-box;
    border-top: 1px dotted $greydark;
    border-bottom: 0;
    color: $black;
    opacity: 0.6;
    transition: opacity 0.3s ease;
    &:hover {
      opacity: 1;
    }
    &:not(.published) {
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
        user-select: none;
        pointer-events: none;
        .panel-tampnail {
            opacity: 0.2;
        }
    }
    .menu-panel-content {
      font-family: $font-CuratorRegular;
      white-space: normal;
      * {
        font-family: inherit;
      }
      h3 {
        font-size: 13px;
        line-height: 16px;
        text-transform: uppercase;
        letter-spacing: 2px;
        margin-bottom: 10px;
      }
      p {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
  img {
    width: 100%;
    max-width: 120px;
    margin-right: 10px;
    vertical-align: top;
  }
}
</style>